import { Discount } from '../../types/DiscountTypes'
import {
  fixMathRounding,
  getActivitiesWithDiscountId,
  getPriceFromCalculation,
  getBasePriceFromCalculation
} from './CalculateDiscountHelpers'
import {
  CalculateDiscountLogic,
  Calculation,
  CalculationDiscount,
  CalculationUserInput,
  DiscountType
} from './CalculateDiscountTypes'

export class SiblingDiscountLogic implements CalculateDiscountLogic {
  type: DiscountType = 'sibling'
  discountDefinition: Discount

  constructor(discount: Discount) {
    this.discountDefinition = discount
  }

  chooseEligible(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    if (!userInput.isSibling) return []

    return getActivitiesWithDiscountId(previousCalculations, this.discountDefinition.id)
  }

  calculate(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    const eligibleActivities = this.chooseEligible(previousCalculations, userInput)

    previousCalculations.map((calculation) => {
      if (!eligibleActivities.includes(calculation.activity.id)) return
      const activityPrice = getPriceFromCalculation(calculation)
      const basePrice = getBasePriceFromCalculation(calculation)
      const discountAmount =
        this.discountDefinition.calculationType === 'amount'
          ? this.discountDefinition.value // amount discount
          : fixMathRounding(basePrice * (this.discountDefinition.value / 100)) // percentage discount on base price
      const siblingDiscount: CalculationDiscount = {
        type: this.type,
        name: this.discountDefinition.name,
        id: this.discountDefinition.id,
        input: activityPrice,
        discount: discountAmount,
        output: fixMathRounding(activityPrice - discountAmount),
        discountCalculationType: this.discountDefinition.calculationType,
        discountValue: this.discountDefinition.value,
        discountGroup: this.discountDefinition.discountGroup
      }
      calculation.discounts = calculation.discounts || []
      calculation.discounts.push(siblingDiscount)
      calculation.finalPrice = siblingDiscount.output
    })

    return previousCalculations
  }
}
